import { Box, VBox } from "@/components-v2/Box";
import { Dialog } from "@/components-v2/Dialog";
import { useTranslation } from "@/stores/RootStoreContext";
import { TMessageKey } from "@/i18n/types.gen";

type ShortcutRow = { keys: string[]; descriptionKey: TMessageKey };

const SHORTCUTS: ShortcutRow[] = [
  { keys: ["g", "o"], descriptionKey: "keyboard-shortcuts.dashboard" },
  { keys: ["g", "s"], descriptionKey: "keyboard-shortcuts.shareholders" },
  { keys: ["g", "d"], descriptionKey: "keyboard-shortcuts.documents" },
  { keys: ["g", "c"], descriptionKey: "keyboard-shortcuts.schedule" },
  { keys: ["g", "a"], descriptionKey: "keyboard-shortcuts.archive" },
  { keys: ["g", "m"], descriptionKey: "keyboard-shortcuts.messaging" },
  { keys: ["?"], descriptionKey: "keyboard-shortcuts.show-shortcuts" },
];

function Kbd({ children }: { children: string }) {
  return (
    <kbd className="border border-solid border-gray-hard bg-default rounded-sm font-mono shadow-xs px-1.5 py-0.5">
      {children}
    </kbd>
  );
}

export function KeyboardShortcutsHelpDialog({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();
  return (
    <Dialog
      title={{ key: "keyboard-shortcuts" }}
      onCancel={onClose}
      cancelLabel={{ key: "close" }}
      maxWidth="xs"
    >
      <VBox>
        {SHORTCUTS.map((row) => (
          <Box key={row.keys.join("+")} gap="md" borderBottom paddingY="sm" alignItems="center">
            <Box gap="xs">
              {row.keys.map((k, i) => (
                <Kbd key={i}>{k}</Kbd>
              ))}
            </Box>
            <span className="text-secondary">{t(row.descriptionKey)}</span>
          </Box>
        ))}
      </VBox>
    </Dialog>
  );
}
